// The 'viewpoint' domain: the asset area these commands operate in.
export const VIEWPOINT_DOMAIN = 'viewpoint' as const;

export const viewpointDomainDescription =
  'The user is working in an interactive visualization or data view. Actions in this ' +
  'domain operate on the current view and may change its presentation or the data ' +
  'configuration shown, for example through view settings, formatting, or layout. ' +
  'They act through the frontend and do not directly modify the underlying workspace ' +
  'data. When the user asks to change, ' +
  'arrange, highlight, configure, or otherwise manipulate what they see in the ' +
  'current view, delegate to handle_ui_command. Do not answer these requests with ' +
  'build_view_preview: it only adds a separate preview in the chat and cannot ' +
  'change the current view. Requests for information about ' +
  'specific components or data, such as "show me Workday", and requests for an ' +
  'explanation, analysis, or textual answer should be handled normally, without ' +
  'delegating, even though view actions are available. When "show" asks for what is ' +
  'on screen to change, such as "show it coloured by cost" or "show it for all ' +
  'applications", it is a view change. If it is unclear whether the ' +
  'user wants an answer or a change to the view, ask which one they mean. ' +
  'The exact actions available ' +
  'for this turn are determined by the UI-command specialist.';
